export default "__VITE_ASSET__DE0_jk9Q__"